<template>
  <main class="how_it_works bb">
    <section>
      <PageBackButton />

      <h1 class="pg_title">{{ $_translations.value[pageInfo.title] }}</h1>

      <h2 class="subtitle">{{ $_translations.value[pageInfo.subtitle] }}</h2>

      <TransparentCard>
        <InfoItem
          v-for="info in infoList"
          :key="info.id"
          :title="info.title"
          :description="info.description"
          :description-el-class="info.descriptionElClass"
        />
      </TransparentCard>
    </section>
  </main>
</template>

<script setup>
import { computed } from 'vue';
import PageBackButton from '@/components/button/PageBackButton.vue';
import TransparentCard from '@/components/card/TransparentCard.vue';
import InfoItem from '@/views/howItWorks/components/InfoItem.vue';
import useAuthStore from '@/store/modules/auth.js';

const authInfoList = [
  { id: 'dailyGames', title: 'page_how_it_works_auth_item_daily_game_title', description: 'page_how_it_works_auth_item_daily_game_description' },
  { id: 'scoringAndWinning', title: 'page_how_it_works_auth_item_scoring_and_winning_title', description: 'page_how_it_works_auth_item_scoring_and_winning_description' },
  { id: 'gamePlay', title: 'page_how_it_works_auth_item_game_play_title', description: 'page_how_it_works_auth_item_game_play_description' },
  { id: 'questionFormat', title: 'page_how_it_works_auth_item_question_format_title', description: 'page_how_it_works_auth_item_question_format_description' },
  { id: 'earnPoints', title: 'page_how_it_works_auth_item_earn_points_title', description: 'page_how_it_works_auth_item_earn_points_description' },
  { id: 'earnGames', title: 'page_how_it_works_auth_item_earn_games_title', description: 'page_how_it_works_auth_item_earn_games_description' },
];

const publicInfoList = [
  { id: 'dailyGames', title: 'page_how_it_works_public_item_daily_game_title', description: 'page_how_it_works_public_item_daily_game_description' },
  { id: 'scoringAndWinning', title: 'page_how_it_works_public_item_scoring_and_winning_title', description: 'page_how_it_works_public_item_scoring_and_winning_description' },
  { id: 'gamePlay', title: 'page_how_it_works_public_item_game_play_title', description: 'page_how_it_works_public_item_game_play_description' },
  { id: 'questionFormat', title: 'page_how_it_works_public_item_question_format_title', description: 'page_how_it_works_public_item_question_format_description' },
  { id: 'earnPoints', title: 'page_how_it_works_public_item_earn_points_title', description: 'page_how_it_works_public_item_earn_points_description' },
  { id: 'earnGames', title: 'page_how_it_works_public_item_earn_games_title', description: 'page_how_it_works_public_item_earn_games_description' },
];

const authStore = useAuthStore();

const pageInfo = computed(() => authStore.isUserAuthenticated
  ? { title: 'page_how_it_works_auth_title', subtitle: 'page_how_it_works_auth_subtitle' }
  : { title: 'page_how_it_works_public_title', subtitle: 'page_how_it_works_public_subtitle' },
);
const infoList = computed(() => authStore.isUserAuthenticated ? authInfoList : publicInfoList);
</script>
